/**
 * Checks if commissioner notes contain malicious or inappropriate content.
 * Calls the backend which uses Gemini API for content validation.
 *
 * @param accessAuthToken Auth0 access token for authentication
 * @param notes The commissioner notes text to validate
 * @returns Promise<{ isMalicious: number }> where 0 = safe, 1 = malicious
 */
export async function checkMaliciousNotes(accessAuthToken: string, notes: string): Promise<{ isMalicious: number }> {
  try {
    console.log("[checkMaliciousNotes] Sending notes for validation...");

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/functions/check_malicious_notes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify({ notes }),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Backend responded with status: ${response.status}`);
    }

    const data = await response.json();
    console.log("[checkMaliciousNotes] Validation response:", data);

    return data;
  } catch (error) {
    console.error("[checkMaliciousNotes] Error validating notes:", error);
    throw error;
  }
}
